// extracted by mini-css-extract-plugin
module.exports = {"AwardsPanel":"AwardsPanel-module__AwardsPanel___29efd","svgContainer":"AwardsPanel-module__svgContainer___3OWqw"};